function t(t){return"function"==typeof t&&"string"==typeof t.styledComponentId}export{t as default};
